export const SOURCES_FETCH_ERROR_MESSAGE =
  "An error occurred loading source data";
